<template>
  <div class="brands">
    <el-row>
      <el-card v-loading="loading" class="data">
        <div class="data-title flex-space-between" slot="header">
          <p> Brands </p>
          <div>
            <el-tooltip content="Create Brand" placement="top">
              <el-button type="success" circle icon="el-icon-plus" @click="openModal"></el-button>
            </el-tooltip>
          </div>
        </div>
        <div>
          <Table />
        </div>
      </el-card>
    </el-row>
    <Modal />
  </div>
</template>

<script>
import Table from "@/modules/admin/brand/components/Table.vue";
import Modal from "@/modules/admin/brand/components/Modal.vue";
import {mapActions, mapMutations, mapState} from "vuex";

export default {
  name: "Index",

  computed: {
    ...mapState('brand', ['loading', 'restrictions'])
  },

  components: { Table, Modal },

  methods: {
    ...mapMutations('brand', ['setModal', 'setModalAction', 'setBrand']),
    ...mapActions('brand', ['getPricingThresholds']),

    openModal() {
      this.setBrand({
        restrictions: this.restrictions.map(r => r.name),
        smartLinks: [], assets: [], socials: [], name: null, company_name: null,
        image: null, logo: null,start_date: null, end_date: null, featured: false, affiliate_generator: false, instagram_challenge: {},
        short_challenge: {}, tiktok_challenge: {}, youtube_regular: {},
      })
      this.setModalAction('create')
      this.setModal(true)
    }
  },

  created() {
    this.getPricingThresholds()
  }
}
</script>
